import { languagesItems } from '@/utils/sharedData/languages'

/**
 * @param path that user want to go
 * @returns is that from IDE
 */
export const isNextToIDE = (path: string): boolean => {
  for (const language of languagesItems) {
    // Remove slash '/'
    path = path.replace('/', '')
    language.link = language.link.replace('/', '')

    if (language.link === path) return true
  }
  return false
}
